import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Menu, MenuItem, Box } from '@mui/material';

import { ReactComponent as ReportRedIcon } from '../../../../assets/images/report_red.svg';
import { CustomModal } from '../../../../components/CustomModal';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { ROUTES } from '../../../../constants/routes';
import { deleteBranch, deleteBranchAction, deleteDepartment } from '../../../../store/company/actions';

export const MoreActions = ({ departmentId, setIsEdit, label, type, branchId }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpenedMore = Boolean(anchorEl);
  const [isOpenModalEmpty, setIsOpenModalEmpty] = useState(false);
  const [isOpenModalNotEmpty, setIsOpenModalNotEmpty] = useState(false);

  const { error } = useSelector((state) => state.company);

  const handleClick = () => {
    setAnchorEl(null);
    setIsOpenModalEmpty(true);
  };

  const handleDelete = () => {
    setIsOpenModalEmpty(false);
    if (type === 'branch') {
      dispatch(deleteBranch(branchId));
    } else {
      dispatch(deleteDepartment(branchId, departmentId));
    }
  };

  useEffect(() => {
    if (error?.id === branchId && type === 'branch') setIsOpenModalNotEmpty(true);
  }, // eslint-disable-next-line
    [error]);

  return (
    <Box>
      <IconButton
        aria-label={`Действия с ${type === 'branch' ? 'филиалом' : 'департаментом'}`}
        aria-haspopup="true"
        aria-expanded={isOpenedMore ? 'true' : undefined}
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <MoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpenedMore}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        data-testid="MoreMenu"
      >
        <MenuItem onClick={() => setIsEdit(true)}>Редактировать</MenuItem>
        <MenuItem
          sx={{
            color: 'error.main'
          }}
          onClick={handleClick}>
          Удалить
        </MenuItem>
      </Menu>
      <CustomModal
        opened={isOpenModalEmpty}
        modalClose={() => setIsOpenModalEmpty(false)}
        modalSubmit={handleDelete}
        text={`Вы действительно хотите удалить ${type === 'branch' ? 'филиал' : 'департамент'} "${label}"?`}
        subText={type === 'branch' ? undefined : 'Данные по департаменту также будут удалены у сотрудника(ов).'}
        cancelBtnName="Отмена"
        submitBtnName="Да"
        data-testid="DeleteModal"
      />
      <CustomModal
        opened={isOpenModalNotEmpty}
        modalClose={() => {setIsOpenModalNotEmpty(false); dispatch(deleteBranchAction.fail(''));}}
        text={`Удаление запрещено!
        Данный филиал установлен у сотрудника(ов)`}
        cancelBtnName="Отмена"
        withoutSubmit
        icon={<ReportRedIcon />}
        submitRoute={ROUTES.TEAM}
        data-testid="tyby"
      />
    </Box>
  );
};

MoreActions.propTypes = {
  departmentId: PropTypes.string,
  setIsEdit: PropTypes.func,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  branchId: PropTypes.string
};
